const FIRST_MESSAGE = "100% human-quality meat";
const SECOND_MESSAGE = "Free from grain, preservatives and sugar";
const THIRD_MESSAGE = "Designed by vets to match cats’ ancestral diets";

export const scrollingBannerMessages = [ FIRST_MESSAGE, SECOND_MESSAGE, THIRD_MESSAGE ];
